// Overview: This file contains 4 slide decks associated with Introduction to Computer Science (ICS) module 1 / sprint 1. Each 
// slidedeck is exported via the ics_1_slidedeckTTR structure.

import { breakoutStandard } from './SLSprint00'
import { se_1_1of4_PAaA, se_1_2of4_PAaA, se_1_3of4_PAaA, xyz_1_1of4, xyz_1_2of4, xyz_1_3of4, xyz_n_4of4, xyz_n_4of4_PAaA } from './SL44000Sprint01TTR'
import { se_2_1of4_PAaA } from './SL44000Sprint02TTR'
import { list20000Sprint01 } from '../ActivityLists/AL20000Sprint01'

// Introduction to Computer Science (ICS) sprint 1 values.
const sprint = 1
const activityList = () => { return list20000Sprint01(sprint) }

const ics_1_1of4 = () => { return xyz_1_1of4(sprint, activityList, se_1_1of4_PAaA, se_1_2of4_PAaA.prework) }
const ics_1_2of4 = () => { return xyz_1_2of4(sprint, activityList, se_1_2of4_PAaA, se_1_3of4_PAaA.prework) }

// Session 3 of 4: Tuesday
const breakoutFileSystemsDirectoriesAndFileName = 'File Systems, Directories, and Files'
const breakoutFileSystemsDirectoriesAndFile = () => {
	return breakoutStandard(
		'Breakout: File Systems, Directories, and Files', 
		'In this breakout session on File Systems, Directories, and Files your team will discuss:', [
			'File Systems, Directories, and Hidden Directories... Do hidden folders keep information safe? ',
			'Files, Hidden Files, File Types, and File Extensions... How do we see hidden files and file extensions?', 
			'How would we utilize graphical and command line tools to view and update File Systems?',
			'What would be a good place to store files for this class? Why?', 
			'What would be examples of questionable places to store files for this class? Why?'])
}

export const ics_1_3of4_PAaA = {
	'prework':[
		'Make your initial Discussion 1 post',
		'Complete through activity 9 prior to next class', 
		`Be prepared for “${breakoutFileSystemsDirectoriesAndFileName}” breakout`,
		'Be prepared for Quiz 1' ],
	'announcements':[
		'Your initial Discussion 1 post was due two days ago',
		'All sprint 1 activities and assignments due Sunday!' ],
	'agenda':[
		'Sprint Progress Polling',
		`Breakout: ${breakoutFileSystemsDirectoriesAndFileName}`,
		'Prework for Next Class',	
		'Quiz 1' ] 	
}
const ics_1_3of4 = () => { return xyz_1_3of4(sprint, activityList, ics_1_3of4_PAaA, ics_1_4of4_PAaA.prework, breakoutFileSystemsDirectoriesAndFile) }

const ics_1_4of4_PAaA = xyz_n_4of4_PAaA('Complete through activity 12', sprint)
const ics_1_4of4 = () => { return  xyz_n_4of4(sprint, activityList, ics_1_4of4_PAaA, se_2_1of4_PAaA.prework ) }

export const ics_1_slidedeckTTR = [ ics_1_1of4, ics_1_2of4, ics_1_3of4, ics_1_4of4 ]